export class HttpException {
    constructor(public statusCode: number, public errorCode: string, public message?: string) {
    }
}